export interface CardTheme {
  id: number;
  background: string;
}

export const cardThemes: CardTheme[] = [
  {
    id: 1,
    background:
      'https://res.cloudinary.com/lapkinthegod/image/upload/v1633425628/horizontal-wide-red-pink-blue-blurred-background_136277-125_bk9drb.jpg',
  },
  {
    id: 2,
    background:
      'https://res.cloudinary.com/lapkinthegod/image/upload/v1633007324/vivid-blurred-colorful-wallpaper-background_1_h1k9sc.png',
  },
  {
    id: 3,
    background: 'https://res.cloudinary.com/lapkinthegod/image/upload/v1633007328/43064_1_z6kdji.png',
  },
  {
    id: 4,
    background:
      'https://res.cloudinary.com/lapkinthegod/image/upload/v1633007330/abstract-luxury-gradient-blue-background-smooth-dark-blue-with-black-vignette-studio-banner_1_x81z7y.png',
  },
  {
    id: 5,
    background: 'https://res.cloudinary.com/lapkinthegod/image/upload/v1633102260/Mask_Group_1_cr4x7l.png',
  },
  {
    id: 6,
    background: 'https://res.cloudinary.com/lapkinthegod/image/upload/v1633102263/Rectangle_917_1_ssqdbc.png',
  },
];
